var map = {
	"./404.svg": "8a81",
	"./Vector.svg": "c64c",
	"./arrow-down.svg": "896a",
	"./arrow-left.svg": "857e",
	"./chevron-left.svg": "254a",
	"./close-2.svg": "8c965",
	"./close.svg": "bf37",
	"./download.svg": "6369",
	"./empty-documents.svg": "f60e",
	"./eye.svg": "83a4",
	"./filter-grid.svg": "17ca",
	"./link.svg": "6bb3",
	"./lock.svg": "3c1a",
	"./logos/agrotools/colorful.svg": "0738",
	"./logos/agrotools/white.svg": "e96b",
	"./mail.svg": "1752",
	"./no-alerts.svg": "00b4",
	"./no-producers.svg": "fe45",
	"./no-results.svg": "b1ac",
	"./notification.svg": "cd87",
	"./options.svg": "f39f",
	"./ordenation.svg": "a61a",
	"./print.svg": "b883",
	"./refresh.svg": "b7d8",
	"./search.svg": "51f2",
	"./timer.svg": "6661",
	"./triangle.svg": "25d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";